export enum ActivityTypeEnum {
  CALL = 1,
  MAIL = 2,
  VIDEO = 3,
  NOTE = 4,
  MEETING = 5,
  OFFER = 6,
}